import { assignVariantToMetafield } from "@theme/utilities";

if (!customElements.get("product-inventory")) {
    class ProductInventory extends HTMLElement {
        constructor() {
            super();
            this.selectedVariant = this.dataset.selectedVariant
                ? parseInt(this.dataset.selectedVariant)
                : null;
            if (this.hidden) {
                this.initLazySection();
            } else {
                window.initLazyScript(this, this.initLazySection.bind(this));
            }
            this.similarButton = this.querySelector("#similar-connector");
        }

        initLazySection() {
            this.inventoryNotice = this.querySelector(".js-inventory-notice");
            this.urgencyMessage = this.querySelector(".js-inventory-urgency");
            this.indicatorBar = this.querySelector(".js-inventory-indicator");
            this.backInStockDateEl = this.querySelector(
                "div[back-in-stock-date]",
            );
            this.backInStockDateSpan =
                this.backInStockDateEl?.querySelector("span[date]") || null;
            this.inStockTextEl = this.querySelector(
                ".product-inventory__status .text-theme-text",
            );

            this.variantInventory = this.getVariantInventory();

            if (this.selectedVariant && this.variantInventory?.length) {
                const currentInventory = this.variantInventory.find(
                    (e) => e.id === this.selectedVariant,
                );
                if (currentInventory) {
                    const backInStockDate = currentInventory.backInStockDate;
                    const showBisDate = currentInventory.showBisDate === "true";
                    this.handleReplaceDate(
                        this,
                        backInStockDate,
                        null,
                        null,
                        showBisDate,
                    );
                }
            }

            const variantPicker =
                this.closest(".product-info").querySelector(
                    "new-variant-picker",
                );
            if (variantPicker) {
                variantPicker.addEventListener(
                    "variant:update",
                    this.handleVariantChange.bind(this),
                );
            }
            if (this.similarButton) {
                this.similarButton.addEventListener("click", () => {
                    const recoEl = document.querySelector(
                        "product-recommendations",
                    );
                    if (recoEl) {
                        recoEl.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }
                });
            }
        }

        getVariantInventory() {
            if (this.variantInventory) return this.variantInventory;
            const dataEl = this.querySelector('[type="application/json"]');
            if (!dataEl) return [];
            return JSON.parse(dataEl.textContent);
        }

        handleVariantChange(evt) {
            if (evt?.detail?.sourceId) {
                const product = evt.detail?.data?.product;

                const variant =
                    evt.detail?.data?.variant ||
                    assignVariantToMetafield(
                        evt?.detail?.resource.variant,
                        evt?.detail?.resource.metafields,
                    );

                if (!variant) return;

                const inventory = this.variantInventory?.find(
                    (inv) => inv.id === variant.id,
                );

                const showBisDate = inventory?.showBisDate === "true";
                const backInStockDate = inventory?.backInStockDate || null;

                const shippingGroup = variant?.metafields?.SHIPPING_GROUPS;

                this.handleReplaceDate(
                    this,
                    backInStockDate,
                    product,
                    variant,
                    showBisDate,
                );

                if (variant.available) {
                    if (shippingGroup === "LTL") {
                        this.dataset.inventoryLevel = "none";
                    } else {
                        this.dataset.inventoryLevel = "normal";
                    }
                } else {
                    this.dataset.inventoryLevel = "none";
                }
            } else {
                this.updateInventory(0, false);
                this.hidden = true;
            }
        }

        updateInventory(count, available, inventoryPolicy) {
            if (count === 0 && !available && this.hidden) {
                return;
            }

            let inventoryLevel;

            if (count <= 0) {
                if (inventoryPolicy === "continue") {
                    inventoryLevel = "backordered";
                } else if (available) {
                    inventoryLevel = "in_stock";
                } else {
                    inventoryLevel = "none";
                }
            } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
                inventoryLevel = "very_low";
            } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
                inventoryLevel = "low";
            } else {
                inventoryLevel = "normal";
            }

            if (
                (this.dataset.showNotice === "always" ||
                    (this.dataset.showNotice === "low" &&
                        inventoryLevel.includes("low"))) &&
                !(
                    inventoryLevel === "backordered" &&
                    this.dataset.showNoStockBackordered === "false"
                )
            ) {
                this.hidden = false;

                this.setAttribute("data-inventory-level", inventoryLevel);

                if (inventoryLevel === "backordered") {
                    this.inventoryNotice.innerText = "";
                } else if (
                    inventoryLevel !== "in_stock" &&
                    (this.dataset.showCount === "always" ||
                        (this.dataset.showCount === "low" &&
                            inventoryLevel.includes("low")))
                ) {
                    this.inventoryNotice.innerText =
                        theme.strings.onlyXLeft.replace("[quantity]", count);
                } else if (inventoryLevel === "very_low") {
                    this.inventoryNotice.innerText = theme.strings.veryLowStock;
                } else if (inventoryLevel === "low") {
                    this.inventoryNotice.innerText = theme.strings.lowStock;
                } else if (
                    inventoryLevel === "normal" ||
                    inventoryLevel === "in_stock"
                ) {
                    this.inventoryNotice.innerText = theme.strings.inStock;
                } else if (inventoryLevel === "none") {
                    this.inventoryNotice.innerText = theme.strings.noStock;
                }

                if (this.urgencyMessage) {
                    if (inventoryLevel === "very_low") {
                        this.urgencyMessage.innerHTML =
                            this.dataset.textVeryLow;
                    } else if (inventoryLevel === "low") {
                        this.urgencyMessage.innerHTML = this.dataset.textLow;
                    } else if (inventoryLevel === "backordered") {
                        this.urgencyMessage.innerHTML =
                            this.dataset.textNoStockBackordered;
                    } else if (
                        inventoryLevel === "normal" ||
                        inventoryLevel === "in_stock"
                    ) {
                        this.urgencyMessage.innerHTML = this.dataset.textNormal;
                    } else if (inventoryLevel === "none") {
                        this.urgencyMessage.innerHTML =
                            this.dataset.textNoStock;
                    }
                }

                if (this.indicatorBar) {
                    this.indicatorBar.hidden = false;

                    let newWidth;
                    if (
                        (count >= this.dataset.scale ||
                            inventoryLevel === "in_stock") &&
                        inventoryLevel !== "backordered"
                    ) {
                        newWidth = 100;
                    } else {
                        newWidth = (
                            (100 / parseInt(this.dataset.scale, 10)) *
                            count
                        ).toFixed(1);
                    }
                    this.indicatorBar.querySelector("span").style.width =
                        `${newWidth}%`;
                }
            } else {
                this.hidden = true;
            }
        }

        handleReplaceDate(html, dateText, product, variant, showBisDate) {
            const backInStockDateEl = html?.querySelector(
                "div[back-in-stock-date]",
            );

            if (backInStockDateEl) {
                const span = backInStockDateEl.querySelector("span[date]");

                if (showBisDate && dateText) {
                    if (span) span.innerText = dateText;
                    backInStockDateEl.style.display = "flex";
                } else {
                    if (span) span.innerText = "";
                    backInStockDateEl.style.display = "none";
                }
            }

            if (product && this.inStockTextEl) {
                this.inStockTextEl.innerHTML = this._findInStockText(
                    product,
                    variant,
                    showBisDate,
                );
            }

            return html;
        }

        _findInStockText(product, variant, showBisDate) {
            if (variant?.available === false) {
            return `This item is currently sold out. <button id="similar-connector" class="underline" onclick="const target = document.querySelector('similar-products'); if(target) { target.scrollIntoView({behavior: 'smooth', block: 'start'});">See Similar Styles</button>`;
            } else if (showBisDate) {
                return "Ships free within 24h after back-in-stock.";
            } else if (product.vendor === "Rug Outlet") {
                return "In stock & ships free within 3 days from Calhoun, GA.";
            } else if (product.vendor === "The Rug Decor") {
                return "Ships within 6-8 weeks.";
            } else if (product.vendor === "Four Hands") {
                return "In stock & ships free within 2-3 weeks from Calhoun, GA.";
            } else if (product.vendor === "Safavieh") {
                return "Ships with in 1 week";
            } else if (product.type === "Rug Accessories") {
                return "In Stock & Ships free within 24h from Calhoun, GA.";
            } else if (variant?.metafields?.SHIPPING_GROUPS === "LTL") {
                return "Oversized items may take more than 5 days to deliver.";
            } else {
                return "In Stock & Ships free within 24h from Calhoun, GA.";
            }
        }
    }

    customElements.define("product-inventory", ProductInventory);
}
